import { useTranslation } from 'react-i18next'
import { Flap } from '@/components/home/DepartureBoard'
import { cn } from '@/lib/utils'

type ScoreFlapsProps = {
  home: number | null
  away: number | null
  /** La dimensione si regola con `text-*`: le palette sono in `em`. */
  className?: string
}

const digits = (value: number) =>
  String(value)
    .split('')
    .map((char, i) => <Flap key={i} char={char} />)

/**
 * Punteggio sulle palette del tabellone partenze della home: cambia cifra e la paletta ricade. Per lettori di
 * schermo e test resta il testo "4 – 1"; senza punteggio (partita da giocare) scrive "vs".
 */
export function ScoreFlaps({ home, away, className }: ScoreFlapsProps) {
  const { t } = useTranslation()
  if (home === null || away === null) {
    return <span className={cn('font-display italic leading-none', className)}>{t('stoccoPong.match.vs')}</span>
  }
  return (
    <span className={cn('inline-flex items-center gap-[0.18em] font-body font-semibold leading-none tabular-nums', className)}>
      <span className="sr-only">{`${home} – ${away}`}</span>
      <span aria-hidden="true" className="flex gap-[0.06em]">{digits(home)}</span>
      <span aria-hidden="true" className="opacity-50">:</span>
      <span aria-hidden="true" className="flex gap-[0.06em]">{digits(away)}</span>
    </span>
  )
}
